import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

// does not support wrapping content
const HorizontalFlow = styled.div`
  ${(props) => {
    const spacing = props.spacing || '0.5rem';
    return css`
      ${mixin.horizontalFlow({ spacing })}
    `;
  }}
`;

export default HorizontalFlow;
